import EllipsisMenu from "../../../../components/EllipsisMenu/EllipsisMenu"
import { ScanMedia } from "../../../../types/types"
import { getDate } from "../../../../utils/utils"
import AnalysisSection from "../AnalysisSection/AnalysisSection"
import { ScanMediaSectionProps } from "./ScanMediaSection.types"
import SkeletonLoadingView from "../../../../components/SkeletonLoadingView/SkeletonLoadingView"
import useEllipsisMenu from "../../../../components/EllipsisMenu/useEllipsisMenu"
import "./ScanMediaSection.css"
import ErrorView from "../SectionError/ErrorView"

const ScanMediaSection = (props: ScanMediaSectionProps) => {
  const { 
    media,
  } = props

  const mediaState = media

  const { ellipsisMenu } = useEllipsisMenu({
    items: [
      {
        item: "Export",
        onClick: () => {}
      }
    ]
  })

  const onImageClick = (src: string) => {
    if (src.startsWith("data:")) {
      const [header, base64Data] = src.split(",");
      const mimeType = header.match(/data:(.*?);base64/)?.[1] ?? "image/png";
  
      const byteCharacters = atob(base64Data);
      const byteArray = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
      }
      const blob = new Blob([byteArray], { type: mimeType });
  
      const objectUrl = URL.createObjectURL(blob);
      const newTab = window.open(objectUrl, "_blank", "noopener,noreferrer");
      newTab?.addEventListener("load", () => URL.revokeObjectURL(objectUrl));
      } else {
      window.open(src, "_blank", "noopener,noreferrer");
    }
  }

  if (!mediaState) { 
    return (
      <AnalysisSection title="Section Images">
        <ErrorView 
          message={"Failed to load section images."}
        />
      </AnalysisSection>
    )
  }

  if (mediaState.status === "loading" || mediaState.status === "idle") {
    return (
      <AnalysisSection title="Section Images">
        <div className="analysis-section">
          <div className="scan-media-container">
            {[...Array(3)].map((_, key) => (
              <div key={key}>
                <SkeletonLoadingView style={{height: "9rem", width: "15rem"}} />
              </div>
            ))}
          </div>
        </div>
      </AnalysisSection>
    )
  }

  if (mediaState.status === "error") {
    return (
      <AnalysisSection title="Workflow">
        <ErrorView 
          message={"Failed to load workflow information."}
        />
      </AnalysisSection>
    )
  }

  const mediaData = mediaState.data
  if (!mediaData) {
    return (
      <div className="no-scan-images-container">
        <p className="no-content-label">No section images available for this section.</p>
      </div>
    )
  }

  return (
    <AnalysisSection title="Scan Images"
      // titleChild={
      //   <EllipsisMenu ellipsisMenu={ellipsisMenu} />
      // }
    >
      <div className="analysis-section">
        <div className="scan-media-container">
          {mediaData.map((m: ScanMedia, key) => (
            <div key={m.id}>
              <img 
                className="scan-media-image" 
                src={`${m.src}`}
                onClick={() => onImageClick(m.src)}
                alt={`Scan media ${key} `}
              />
              <p className="date-text">{getDate(m.date)}</p>
            </div>
          ))}
        </div>
        {mediaData.length === 0 && (
          <div className="no-scan-images-container">
            <p className="no-content-label">No scan images available for this section.</p>
          </div>
        )}
      </div>
    </AnalysisSection>
  )
}

export default ScanMediaSection